import * as Yup from "yup";

const passwordSchema = Yup.string()
  .matches(/(?=.*?\d)/, "number")
  .matches(/(?=.*?[A-ZÀ-ÖØ-Þ])/, "uppercase")
  .matches(/(?=.*?[a-zá-öø-þ])/, "lowercase")
  .matches(/(?=.*?[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~ ])/, "special")
  .required()
  .trim();

export const registerValidationSchema = Yup.object({
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  password: passwordSchema,
});

export const resetValidationSchema = Yup.object({
  code: Yup.array().of(Yup.string().required("Code is required")),
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  password: passwordSchema,
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required(),
});

export const completeValidationSchema = Yup.object({
  password: passwordSchema,
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Required"),
});
